import { useNavigate } from 'react-router-dom';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { hqRoutes } from 'hq/Routes';
import { useAlert } from 'shared/components/alerts';
import { useTranslation } from 'react-i18next';
import { useGetIssueDocumentDialog } from './hooks/use-get-issue-document-dialog';
import { useIssueDocument } from '../use-issue-document';
import { IssueDocumentFormData } from '../../../issue-document-form-content/issue-document-form-content.types';

export const useIssueDocumentFormActions = () => {
  const { closeDialog, openDocumentDialog } = useGetIssueDocumentDialog();
  const mutation = useIssueDocument();
  const navigate = useNavigate();
  const generatePath = useHqRelativePath();
  const { t } = useTranslation('hq-screen-specific');
  const { alertSuccess, alertError } = useAlert();
  const redirectPath = generatePath(hqRoutes.DocumentsPage, undefined);

  const handleCancel = () => {
    closeDialog();
    navigate(redirectPath);
  };

  const handleIssueDocument = (formData: IssueDocumentFormData) => {
    const { flexWorkerOption, documentType, ...rest } = formData;

    openDocumentDialog(() => {
      mutation.mutate(
        {
          workerId: flexWorkerOption?.value || '',
          documentType: documentType,
          dynamicProperties: { ...rest },
        },
        {
          onSuccess: () => {
            alertSuccess(
              t('documents.issue_document.success_message', { ns: 'hq-screen-specific' })
            );
            closeDialog();
            navigate(redirectPath);
          },
          onError: (e) => {
            alertError(e);
            closeDialog();
          },
        }
      );
    });
  };

  return {
    handleIssueDocument,
    handleCancel,
  };
};
